<template>
  <div>
    <Bar :data="fondsStore.barChartConfig" :options="options" id="my-chart-id"></Bar>
  </div>
</template>

<script setup lang="ts">
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { useFondsStore } from '@/stores/fonds'
import { options } from '@/components/ChartConfig/BarChartConfig'

const fondsStore = useFondsStore()

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
</script>
